define('shared/initializer/form/newHouseAdapters/Payment',[ 
    'shared/lib/ctor', 
    'shared/lib/RSVP',
    './Checkout', 
    '../adapters/mixins/InputValueRecoverable',
    './mixins/OrderInfoStorable',
    './mixins/OffersInfoStorable',
    './mixins/PaymentSuccessHandlable',
    './mixins/NoCardDebugletable'
], 
function ( 
    ctor, 
    RSVP, 
    Checkout, 
    InputValueRecoverable,
    OrderInfoStorable,
    OfferInfoStorable,
    PaymentSuccessHandlable,
    NoCardDebugletable
) {
    'use strict';

    var Ctor = ctor(function() {
        var me = this;
        me.base.apply(me, arguments);

        me.mixin(
            InputValueRecoverable,
            OrderInfoStorable,
            OfferInfoStorable,
            PaymentSuccessHandlable,
            NoCardDebugletable
        );
    }).inherit(Checkout); 

    return Ctor;
});
